import { deleteQuery, getQuery, insertQuery } from "./UdasWrapper";
import { addErrorLog } from "Logger/logger";

const toResourceDependencyInput = ({
  sourceId,
  targetId,
  sourceResourceType,
  targetResourceType,
  contextId
}) => ({
  source_id: sourceId,
  target_id: targetId,
  source_resource_type: sourceResourceType,
  target_resource_type: targetResourceType,
  context_id: contextId
});

export const createResourceDependency = async (input) => {
  const { tenantId } = input;
  const data = JSON.stringify({
    query: `mutation CreateResourceDependency($tenantId: String!, $input: ResourceDependencyInput!) {
      createResourceDependency(tenant_id: $tenantId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      input: toResourceDependencyInput(input)
    }
  });

  try {
    return (await insertQuery(data))?.createResourceDependency;
  } catch (error) {
    addErrorLog("mutation CreateResourceDependency", error, tenantId);
    throw error;
  }
};

export const createResourceDependencies = async ({
  tenantId,
  dependencies
}) => {
  const data = JSON.stringify({
    query: `mutation CreateResourceDependencies($tenantId: String!, $input: [ResourceDependencyInput!]!) {
      createResourceDependencies(tenant_id: $tenantId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      input: dependencies.map(toResourceDependencyInput)
    }
  });

  try {
    return (await insertQuery(data))?.createResourceDependencies;
  } catch (error) {
    addErrorLog("mutation CreateResourceDependencies", error, tenantId);
    throw error;
  }
};

export const deleteResourceDependency = async (input) => {
  const { tenantId } = input;
  const data = JSON.stringify({
    query: `mutation DeleteResourceDependency($tenantId: String!, $input: ResourceDependencyInput!) {
      deleteResourceDependency(tenant_id: $tenantId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      input: toResourceDependencyInput(input)
    }
  });

  try {
    return (await deleteQuery(data))?.deleteResourceDependency;
  } catch (error) {
    addErrorLog("mutation DeleteResourceDependency", error, tenantId);
    throw error;
  }
};

export const deleteResourceDependencies = async ({
  tenantId,
  dependencies
}) => {
  const data = JSON.stringify({
    query: `mutation DeleteResourceDependencies($tenantId: String!, $input: [ResourceDependencyInput!]!) {
      deleteResourceDependencies(tenant_id: $tenantId, input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      input: dependencies.map(toResourceDependencyInput)
    }
  });

  try {
    return (await deleteQuery(data))?.deleteResourceDependencies;
  } catch (error) {
    addErrorLog("mutation DeleteResourceDependencies", error, tenantId);
    throw error;
  }
};

export const updateResourceDependency = async ({
  tenantId,
  oldInput,
  newInput
}) => {
  const data = JSON.stringify({
    query: `mutation UpdateResourceDependency($tenantId: String!, $oldInput: ResourceDependencyInput!, $newInput: ResourceDependencyInput!) {
      updateResourceDependency(tenant_id: $tenantId, oldInput: $oldInput, newInput: $newInput) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      oldInput: toResourceDependencyInput(oldInput),
      newInput: toResourceDependencyInput(newInput)
    }
  });

  try {
    return (await insertQuery(data))?.updateResourceDependency;
  } catch (error) {
    addErrorLog("mutation UpdateResourceDependency", error, tenantId);
    throw error;
  }
};


export const getResourceDependencies = async ({
  tenantId,
  sourceId,
  direction,
  targetResourceType
}) => {
  const data = JSON.stringify({
    query: `query GetResourceDependencies($tenantId: String!, $sourceId: ID!, $direction: String!, $targetResourceType: String) {
      getResourceDependencies(
        tenant_id: $tenantId
        source_id: $sourceId
        direction: $direction
        target_resource_type: $targetResourceType
      ) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      sourceId,
      direction,
      targetResourceType
    }
  });

  try {
    return (await getQuery(data))?.getResourceDependencies;
  } catch (error) {
    addErrorLog("query GetResourceDependencies", error, tenantId);
    throw error;
  }
};

export const getResourceDependenciesWithHop = async ({
  tenantId,
  ...input
}) => {
  const data = JSON.stringify({
    query: `query GetResourceDependenciesWithHop(
      $tenantId: String!
      $input: ResourceDependencyHopInput!
    ) {
      getResourceDependenciesWithHop(
        tenant_id: $tenantId
        input: $input
      ) {
        isSuccessful
        message
        resultObject
      }
    }`,
    variables: {
      tenantId,
      input: {
        source_id: input.sourceId,
        direction: input.direction,
        direct_target_resource_type: input.directTargetResourceType,
        through_target_resource_type: input.throughTargetResourceType,
        through_direction: input.throughDirection,
        final_target_resource_type: input.finalTargetResourceType,
        context_id_prefix: input.contextIdPrefix,
        target_id_from_context_id: input.targetIdFromContextId
      }
    }
  });

  try {
    return (await getQuery(data))?.getResourceDependenciesWithHop;
  } catch (error) {
    addErrorLog("query GetResourceDependenciesWithHop", error, tenantId);
    throw error;
  }
};
